var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-date-picker',{attrs:{"value":_vm.dateValue,"allowClear":"","placeholder":_vm.placeholder,"valueFormat":"YYYY-MM-DD"},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }